import React from 'react';
import { Input } from 'antd';
import controller from './Controller';
class Main extends React.Component {
  static defaultProps = {
    pluginOptions: {
      height: 200,
    },
    id: 'richtextarea',
    value: '',
  }
  componentWillMount() {
    this.inputId = "input_" + this.props.id;
  }
  componentDidMount() {
    this.plugin = window.CKEDITOR.replace(this.inputId, this.props.pluginOptions);
    controller.addInstanceReadyListener(this, this.inputId);
    this.ready = false;
    this.queue = [];
    this.setData(this.props.value);
  }
  componentWillReceiveProps(nextProps) {
    /**
         * 设置不可编辑状态
         */
    if (nextProps.disabled !== this.props.disabled) {
      this.trySetReadOnly(nextProps.disabled);
    }
		/**
		 * 设置内容
		 */
    if (nextProps.value !== this.props.value && !this.ready) {
      this.trySetData(nextProps.value);
    }
  }
  componentWillUnmount() {
    window.CKEDITOR.remove(this.plugin);
  }
  instanceReady = () => {
    const cke = this.plugin.container.$;
    this.ckeContent = cke.querySelector(".cke_contents");
    this.iframeDocument = this.ckeContent.querySelector("iframe").contentWindow.window.document.documentElement;
    this.initHeight = this.ckeContent.offsetHeight;
    this.ckeContent.style.height = Math.max(this.iframeDocument.offsetHeight, this.initHeight) + "px";
    this.plugin.on('change', (e) => {
      let data = this.plugin.getData();
      if (this.isEmpty(data)) data = "";
      this.props.onChange && this.props.onChange(data);
      this.adjustHeight();
    })
    this.plugin.on("blur", (e) => {
      let data = this.plugin.getData();
      if (this.isEmpty(data)) data = "";
    });
    this.ready = true;
    this.queue.forEach(function (el) {
      el.fn.call(this, el.option);
    });
  }
  isEmpty = (s) => {
    s = s.replace(/&nbsp;/g, "").replace(/\s/g, "").replace(/\\t/g, "").replace(/\\n/g, "");
    s = s.replace(/<p><\/p>/g, "");
    return !s;
  }
  adjustHeight = () => {
    const h = Number(this.ckeContent.style.height.split('px')[0]);
    if (h < this.iframeDocument.offsetHeight || h < this.initHeight)
      this.ckeContent.style.height = Math.max(this.iframeDocument.offsetHeight, this.initHeight) + "px";

  }
  clear = () => {
    this.plugin.setData("");
  }
  trySetReadOnly = (bool) => {
    if (this.ready) {
      this.setReadOnly(bool);
    } else {
      this.queue.push({
        fn: this.setReadOnly,
        option: bool
      })
    }
  }
  setReadOnly = (bool) => {
    this.plugin.setReadOnly(bool);
  }
  trySetData = (value) => {
    if (this.ready) {
      this.setData(value);
    } else {
      this.queue.push({
        fn: this.setData,
        option: value
      })
    }
  }
  setData = (value) => {
    this.plugin.setData(value);
  }
  getData = () => {
    return this.plugin.getData();
  }
  render() {
    const { className } = this.props;
    return (
      <div className={className}>
        <Input type="textarea" id={this.inputId} value={this.props.value} onChange={() => {}} disabled={this.props.disabled} />
      </div>
    )
  }
}
export default Main;



// WEBPACK FOOTER //
// ./src/coms/rich/RichTextArea.js